import { useAccount } from '@shared/state/accountStore';
import { useAccounts } from '@features/trades/hooks/useTradeMetadata';

/**
 * True while the GLOBALLY selected account is a Rithmic account — the conformance gate for showing
 * Rithmic's marks on surfaces that aren't Rithmic-specific (the app footer, the top bar). Their
 * artwork must be displayed when the app is using their software, and must NOT appear for a user
 * scoped to a CQG / imported account.
 *
 * Extracted 2026-07-24 so the footer and top bar share ONE definition of "using Rithmic" — the footer
 * previously inlined it, and a second inlined copy in the top bar is exactly the kind of drift that
 * let the Trading-Platform trademark notice go missing from the footer.
 *
 * Note this is deliberately narrower than `AccountsPanel`'s gate (which shows the marks whenever a
 * Rithmic account is LISTED, because that panel prints Rithmic-derived ids for every row).
 */
export function useRithmicAccountSelected(): boolean {
  const selectedName = useAccount();
  const accounts = useAccounts();
  return (accounts.data ?? []).some(a => a.name === selectedName && a.provider === 'rithmic');
}
